<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="singleblock">
                <!--使用者資料-->
                <el-dialog :title="dialogTitle" width="40%" v-model="dialogFormVisible" :show-close="false" top="5vh" :visible="true"
                           center :close-on-click-modal="false" :lock-scroll="false">
                    <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="Login ID" prop="USER_CODE">
                                    <el-input v-model="form.USER_CODE" :disabled="IDdisabled"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="姓名" prop="USER_NAME">
                                    <el-input v-model="form.USER_NAME"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="連絡電話" prop="TEL_NO">
                                    <el-input v-model="form.TEL_NO"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="E-MAIL" prop="EMAIL">
                                    <el-input v-model="form.EMAIL"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="Set Password" prop="PASSWORD">
                                    <el-input v-model="form.PASSWORD" type="password" show-password></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col style="padding: 0 6px;">
                                <el-form-item label="Confirm Password" prop="PASSWORD_AGAIN">
                                    <el-input v-model="form.PASSWORD_AGAIN" type="password" show-password></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <template #footer class="dialog-footer">
                        <el-button type="primary" @click="oAuth2()" style="width: 150px;" v-show="showLineBtn">Line連通</el-button>
                        <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">Save</el-button>
                    </template>
                </el-dialog>

                <!--<UserInfo ref="userForm" @interface="getInterface"></UserInfo>-->
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    //import UserInfo from '@/components/UserInfo.vue';
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    import { User } from '@element-plus/icons-vue';
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('我的資料');//dialog標題
    const dialogFormVisible = ref(true);//顯示dialog
    const IDdisabled = ref(true);//編輯時ID狀態
    const showLineBtn = ref(true);
    const formRef = ref(null);
    const formData = ref(null);

    const form = ref({
        VENDOR_ID: '',
        USER_CODE: '',
        USER_NAME: '',
        EMAIL: '',
        TEL_NO: '',
        ROLE_ID: '',
        ACCT_ENABLE: 'Y',
        PWD_EXPIRY_DATE: '',
        PASSWORD: '',
        PASSWORD_AGAIN: '',
    });

    const rules = reactive({
        USER_CODE: [{ required: true, message: '請輸入員工代碼', trigger: 'blur' }],
        USER_NAME: [{ required: true, message: '請輸入員工姓名', trigger: 'blur' }],
        ROLE_ID: [{ required: true, message: '請輸入角色', trigger: 'blur' }],
        PASSWORD: [{
            validator: (rule, value, callback) => {
                if ( value == undefined && form.value.PASSWORD_AGAIN != undefined) {
                    callback(new Error('請輸入密碼'));
                }
                callback();
            }, trigger: 'blur'
        }],
        PASSWORD_AGAIN: [{
            validator: (rule, value, callback) => {
                if (form.value.PASSWORD != undefined && value == undefined) {
                    callback(new Error('請再次輸入密碼'));
                } else if (value !== form.value.PASSWORD) {
                    if (form.value.PASSWORD == undefined) formRef.value.validateField('PASSWORD');
                    callback(new Error('兩次輸入密碼不一致!'));
                } else {
                    callback();
                }
            }, trigger: 'blur'
        }]
    });

    onBeforeMount(() => {
        //getMyData
        $api.GET('/api/OutletUser/GetUserInfo').then((response) => {
            form.value = response;
        });
    })

    onMounted(() => {
        switch (localStorage.getItem("VendorType")) {
            case "門店":
            case "品牌":
            case "餐飲平台":
                showLineBtn.value = false;
                break;
            default:
                showLineBtn.value = true;
                break;
        }
    });

    const oAuth2 = () => {
        var USER_SEQ = localStorage.getItem('OtlUserSeq');
        var URL = 'https://notify-bot.line.me/oauth/authorize?';
        URL += 'response_type=code';
        URL += '&client_id=oduC0xD6qMRQ54N6xvn6nl';
        // 工研院  URL += '&redirect_uri=http://tracking.logistics.org.tw/LineNotify/Logistics/pages/TakeUserCode.aspx';   //工研院
        URL += '&redirect_uri=https://lab.multicast.tw/Logistics/pages/TakeUserCode.aspx';  // NB
        // 公司測試機  URL += '&redirect_uri=http://192.168.0.6:10000/Logistics/pages/TakeUserCode.aspx';  // 公司
        URL += '&scope=notify';
        URL += '&state=' + USER_SEQ + '$METE';
        window.location.href = URL;
    }

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                $api.POST('/api/OutletUser/Save', form.value
                ).then((res) => {
                    if (res == 1) {
                        ElMessageBox.alert('編輯成功!', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                form.value.PASSWORD = '';
                                form.value.PASSWORD_AGAIN = '';
                            }
                        });
                    } else {
                        ElMessageBox.alert('編輯失敗!', '提示', {
                            confirmButtonText: '確定'
                        });
                    }
                })
            }
        });
    };

</script>
<style>
    #pane-\/MyData .el-overlay, .el-overlay-dialog {
        position: relative;
    }
</style>